// extracted by mini-css-extract-plugin
export default {"geniusHighlightBottomSheetButton":"FlightCardGeniusHighlightBottomSheetWrapper-module__geniusHighlightBottomSheetButton___X8RSC"};